var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "additional-warehouse-modal", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c(
              "div",
              { staticClass: "modal-content additonal-modal-content" },
              [
                _c(
                  "div",
                  { staticClass: "modal-header additional-modal-header" },
                  [
                    _c("div", { staticClass: "box-item-header" }, [
                      _c("div", { staticClass: "left-item" }, [
                        _c("div", { staticClass: "left-item-header-one" }, [
                          _c("img", {
                            staticClass: "logi-icon img-responsive",
                            attrs: { src: _vm.logiSetting.iconUrl, alt: "" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "left-item-header-two" }, [
                          _c(
                            "p",
                            {
                              class:
                                "logi-kbn m-b-none " +
                                _vm.logiSetting.logiKbnItem.class
                            },
                            [_vm._v(_vm._s(_vm.logiSetting.logiKbnItem.name))]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "logi-name m-b-none" }, [
                            _vm._v(_vm._s(_vm.logiSetting.logiName))
                          ])
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "box-guideline" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "box-btn-view-pdf text-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-view-pdf w-150",
                          attrs: {
                            href: _vm.viewGuidelinePdfUrl,
                            target: "_blank"
                          }
                        },
                        [_vm._v("PDFでみる")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-description" }, [
                    _c("div", {
                      staticClass: "description",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.replaceHTMLSellerInfo(_vm.logiSetting.description)
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "box-action" }, [
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "w-100",
                          attrs: { "data-dismiss": "modal" },
                          on: {
                            click: function($event) {
                              _vm.$emit("close")
                            }
                          }
                        },
                        [_vm._v("閉じる")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "box-agree" }, [
                      _c("input", {
                        attrs: { type: "checkbox", name: "agree", id: "agree" },
                        on: {
                          click: function($event) {
                            _vm.isAgree = !_vm.isAgree
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "agree" } }, [
                        _vm._v("上記書面の内容を読み、同意します。")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-warning btn-add w-130",
                          attrs: { type: "button", disabled: !_vm.isAgree },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.handleClickRegister()
                            }
                          }
                        },
                        [_vm._v("同意する")]
                      )
                    ])
                  ])
                ])
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "guideline" }, [
      _vm._v("\n              ガイドライン／利用規約をご確認いただき、"),
      _c("span", { staticStyle: { color: "#ff0000" } }, [
        _vm._v("「同意する」ボタンをクリックしてください。")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0357c85f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0357c85f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouses/AdditionalWarehouseModal.vue
// module id = null
// module chunks = 